import { Injector } from '@angular/core';
import { WorkflowExternalConfigService } from '../../service/workflow-external-config/workflow-external-config.service';
import { FilterFlowRouteArgs } from '../../service/workflow/workflow.service';
import { ModuleInitializer } from '../module-initializer/module-initializer.class';

// tslint:disable-next-line: completed-docs
export class DynamicWorkflowInitializer {
  public static register(injector: Injector, routeFilter: FilterFlowRouteArgs, ...initializers: ModuleInitializer[]): void {
    const externalConfigService = injector.get(WorkflowExternalConfigService);
    externalConfigService.externalConfigMerged$.subscribe(() => {
      DynamicWorkflowInitializer.RegisterRoutes(injector, routeFilter, initializers);
    });

    DynamicWorkflowInitializer.RegisterLogics(injector, initializers);
    DynamicWorkflowInitializer.RegisterRoutes(injector, routeFilter, initializers);
  }

  private static RegisterLogics(injector: Injector, initializers: ModuleInitializer[]): void {
    for (const initializer of initializers) {
      initializer.RegisterLogicServices(injector);
    }
  }

  private static RegisterRoutes(injector: Injector, routeFilter: FilterFlowRouteArgs, initializers: ModuleInitializer[]): void {
    for (const initializer of initializers) {
      initializer.RegisterRoutes(injector, routeFilter);
    }
  }
}
